
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2.5 2.5v7h7V6h1v3.5c0 .55-.45 1-1 1h-7a1 1 0 01-1-1v-7a1 1 0 011-1H6v1H2.5zm4.5 0v-1h3.5V5h-1V3.205L4.585 8.12l-.705-.705L8.795 2.5H7z","fill":"#585858"}})])
          )
        }
      }
    